import * as React from 'react'

const AgreementIcon = () => (
  <svg
    width="39"
    height="40"
    viewBox="0 0 39 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.7699 40.3944H1.96306C1.83659 40.3944 1.71135 40.3695 1.59451 40.3211C1.47766 40.2727 1.3715 40.2018 1.28207 40.1124C1.19264 40.0229 1.12172 39.9168 1.07332 39.7999C1.02493 39.6831 1 39.5579 1 39.4314V1.96305C1 1.83658 1.02493 1.71135 1.07332 1.59451C1.12172 1.47766 1.19264 1.3715 1.28207 1.28207C1.3715 1.19264 1.47766 1.12171 1.59451 1.07331C1.71135 1.02491 1.83659 1 1.96306 1H31.9822C32.2369 1.00215 32.4806 1.1043 32.6608 1.28445C32.8409 1.46459 32.9431 1.7083 32.9452 1.96305V39.4314C32.9431 39.6861 32.8409 39.9299 32.6608 40.11C32.4806 40.2901 32.2369 40.3923 31.9822 40.3944H7.46148"
      fill="#005AA3"
    />
    <path
      d="M4.7699 40.3944H1.96306C1.83659 40.3944 1.71135 40.3695 1.59451 40.3211C1.47766 40.2727 1.3715 40.2018 1.28207 40.1124C1.19264 40.0229 1.12172 39.9168 1.07332 39.7999C1.02493 39.6831 1 39.5579 1 39.4314V1.96305C1 1.83658 1.02493 1.71135 1.07332 1.59451C1.12172 1.47766 1.19264 1.3715 1.28207 1.28207C1.3715 1.19264 1.47766 1.12171 1.59451 1.07331C1.71135 1.02491 1.83659 1 1.96306 1H31.9822C32.2369 1.00215 32.4806 1.1043 32.6608 1.28445C32.8409 1.46459 32.9431 1.7083 32.9452 1.96305V39.4314C32.9431 39.6861 32.8409 39.9299 32.6608 40.11C32.4806 40.2901 32.2369 40.3923 31.9822 40.3944H7.46148"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M30.9285 28.6815V37.5876C30.9285 37.8452 30.8262 38.0923 30.6441 38.2744C30.4619 38.4566 30.2149 38.5589 29.9573 38.5589H3.98788C3.73028 38.5589 3.48323 38.4566 3.30108 38.2744C3.11893 38.0923 3.0166 37.8452 3.0166 37.5876V1.96305C3.01877 1.70688 3.12205 1.46194 3.30397 1.28157C3.48589 1.10119 3.7317 0.999991 3.98788 1H29.9573C30.2135 0.999991 30.4593 1.10119 30.6412 1.28157C30.8231 1.46194 30.9264 1.70688 30.9285 1.96305V24.8128"
      fill="white"
    />
    <path
      d="M30.9285 28.6815V37.5876C30.9285 37.8452 30.8262 38.0923 30.6441 38.2744C30.4619 38.4566 30.2149 38.5589 29.9573 38.5589H3.98788C3.73028 38.5589 3.48323 38.4566 3.30108 38.2744C3.11893 38.0923 3.0166 37.8452 3.0166 37.5876V1.96305C3.01877 1.70688 3.12205 1.46194 3.30397 1.28157C3.48589 1.10119 3.7317 0.999991 3.98788 1H29.9573C30.2135 0.999991 30.4593 1.10119 30.6412 1.28157C30.8231 1.46194 30.9264 1.70688 30.9285 1.96305V24.8128"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6436 31.2407C13.7094 33.6031 13.9069 34.9694 16.3269 34.2863C18.5329 33.6607 21.0681 31.9404 20.8541 33.2574C20.64 34.5743 22.5003 34.5579 23.9902 33.0104"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.8383 31.9409L23.8174 33.0603L23.9821 29.8502L26.8383 31.9409Z"
      fill="white"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M35.4415 14.2277L23.9814 29.8516L26.8354 31.9449L38.2955 16.3211L35.4415 14.2277Z"
      fill="white"
      stroke="#005AA3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.9532 13.6172L38.1192 13.7389C38.4712 13.9971 38.7063 14.3846 38.7726 14.8162C38.839 15.2477 38.7312 15.6879 38.4729 16.04L37.3824 17.5267L34.5284 15.4333L35.6043 13.9665C35.7328 13.7857 35.8964 13.6327 36.0854 13.5167C36.2745 13.4007 36.485 13.324 36.7044 13.2914C36.9237 13.2588 37.1475 13.2708 37.3621 13.3268C37.5767 13.3828 37.7777 13.4816 37.9532 13.6172Z"
      fill="#005AA3"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M37.407 17.5361L38.3701 18.244C38.5658 18.3886 38.6965 18.6048 38.7335 18.8453C38.7705 19.0859 38.7109 19.3313 38.5676 19.5281L33.3984 26.5822"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.6348 8.79492H21.3474"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.45312 13.314H27.529"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.45312 17.3887H27.529"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.45312 21.751H27.529"
      stroke="#005AA3"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default AgreementIcon
